import LoadingButton from "@mui/lab/LoadingButton";
import React from "react";
import { GlobalDataContext } from "../../contexts/GlobalData";
import useUser from "../../hooks/useUser";
import { useTranslation } from "react-i18next";

export default function MyLoadingButton({
  isLoading,
  permissions = [],
  message,
  disable = false,
  size = "large",
  className = "",
  testId,
  ...rest
}) {
  const { isPermissionAllowed } = React.useContext(GlobalDataContext);
  const { roles } = useUser();
  const { t } = useTranslation();
  function shouldDisable() {
    if (disable) {
      return true;
    }
    if (roles.master) {
      return false;
    }
    if (permissions.length > 0) {
      return !permissions.some((permission) => isPermissionAllowed(permission));
    }
    return false;
  }

  return (
    <LoadingButton
      size={size}
      disabled={shouldDisable()}
      variant="contained"
      loading={isLoading}
      type="submit"
      loadingPosition="center"
      className={className}
      data-testid={testId && testId}
      {...rest}
    >
      <span>{isLoading ? null : t(message)}</span>
    </LoadingButton>
  );
}
